import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Avatar, Dropdown, Menu, Spin, Button, Modal } from "antd";
import { TagStatus } from "../../commons";
import { EllipsisOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import * as Swal from "sweetalert2";
import { Link } from "react-router-dom";
import moment from "moment";
import "moment/locale/th";
import { refreshToken } from "../../utils/refreshToken";
import { AdvancedTableSearch } from "../../views";
import { eventsApi } from "../../../apis";
import { userAction } from "../../../store/action";
import { Layout } from "../../containers";

const { confirm } = Modal;

class CheckInEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      data: [],
      start: 0,
      length: 20,
      search: "",
      total: 0,
      modalCheckInEventId: 0,
      modalCheckInEventName: "",
      modalCheckInEventImg: "",
      dataPrint: [],
      check_token: false,
    };
  }

  componentDidMount = () => {
    this.checkToken();
  };

  componentWillUnmount() {
    clearInterval(this.timeout);
  }

  checkToken = async () => {
    const now = moment().unix();
    if (now >= localStorage.getItem("exp_access_token")) {
      const check = await refreshToken();
      if (check) {
        this.timeout = setTimeout(() => {
          this.fetchData();
        }, 1);
      } else {
        window.location.href = "/";
      }
    } else {
      this.fetchData();
    }
  };

  fetchData = async () => {
    this.setState({
      check_token: true,
    });
    await this.setState({ loading: true });
    const { start, length, search } = this.state;
    await eventsApi.eventCheckInTable(start, length, search).then((resp) => {
      this.setState((prevState) => ({
        ...prevState,
        data: resp.data,
        total: resp.recordsTotal,
        loading: false,
      }));
    });

    await eventsApi.eventCheckInTableReport().then((resp) => {
      const data = [];
      resp.data.forEach((element) => {
        data.push({
          created_at: element.created_at,
          place: element.events_details.place,
          detail: element.events_details.detail,
          end_date: element.events_details.end_date,
          start_date: element.events_details.start_date,
          status: element.status,
          points: element.points,
          name: element.name,
          id: element.id,
        });
        this.setState((prevState) => ({
          ...prevState,
          dataPrint: data,
          loading: false,
        }));
      });
    });
    this.onLoadUser();
  };

  onLoadUser = async () => {
    this.props.userAction.userProfile();
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = async () => {
    this.setState({ loading: true });
    const { modalCheckInEventId } = this.state;
    await this.setState({
      visible: false,
    });
    await eventsApi.deleteEventCheckIn(modalCheckInEventId).then((resp) => {
      Swal.fire({
        icon: "success",
        title: `${resp.message}`,
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        this.setState({
          loading: false,
        });
        this.componentDidMount();
      });
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleSearch = (value) => {
    this.setState({ loading: true });
    const { length } = this.state;
    const token = localStorage.getItem("auth");

    eventsApi.eventCheckInTable(0, length, value, token).then((resp) => {
      this.setState((prevState) => ({
        ...prevState,
        data: resp.data,
        loading: false,
      }));
    });
  };

  handlePaggination = (start, length, search) => {
    this.setState({ loading: true });
    this.setState((prevState) => ({
      ...prevState,
      start,
      length,
      search,
    }));
    const token = localStorage.getItem("auth");
    eventsApi.eventCheckInTable(start, length, search, token).then((resp) => {
      this.setState((prevState) => ({
        ...prevState,
        data: resp.data,
        total: resp.recordsTotal,
        loading: false,
      }));
    });
  };

  onChangeSwitch = (record) => {
    this.setState({ loading: true });
    const status = record.status === 1 ? 0 : 1;
    const { id } = record;
    const { start, length, search } = this.state;

    eventsApi
      .eventCheckInStatusUpdate(id, status)
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: `${response.message}`,
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          this.setState((prevState) => ({
            ...prevState,
            start,
            length,
            search,
          }));
          eventsApi.eventCheckInTable(start, length, search).then((resp) => {
            this.setState((prevState) => ({
              ...prevState,
              data: resp.data,
              total: resp.recordsTotal,
              loading: false,
            }));
          });
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "success",
          title: `${error.response.data.message}`,
          timer: 1500,
          showConfirmButton: false,
        });
      });
  };

  render() {
    const menus = this.props.menu;
    // type 1 = read, 2 = create, 3 = update, 4 = delete
    const isCreate = [];
    const isEdit = [];
    const isDelete = [];
    menus &&
      menus[18].actions.forEach((doc) => {
        if (doc.type === 2 && doc.status === 1) {
          isCreate.push(1);
        } else if (doc.type === 3 && doc.status === 1) {
          isEdit.push(1);
        } else if (doc.type === 4 && doc.status === 1) {
          isDelete.push(1);
        }
      });
    const menu = (record) => (
      <Menu>
        <Menu.Item>
          <Link to={`/check-in-event/${record.id}`}>View</Link>
        </Menu.Item>
        {isEdit[0] === 1 && (
          <Menu.Item>
            <Link to={`/check-in-event/${record.id}/edit`}>Edit</Link>
          </Menu.Item>
        )}
        {isDelete[0] === 1 && (
          <Menu.Item>
            <Link
              to="/check-in-event"
              onClick={() => {
                confirm({
                  title: "ต้องการลบอีเว้นท์นี้ออกจากระบบใช่หรือไม่?",
                  centered: true,
                  icon: <ExclamationCircleOutlined />,
                  onOk() {
                    this.handleOk();
                  },
                });
              }}
            >
              Delete
            </Link>
          </Menu.Item>
        )}
      </Menu>
    );

    const columns = [
      {
        title: "Title",
        dataIndex: "name",
        key: "title",
        type: "input",
        value: "",
        selectData: [],
        onChange: () => console.log("ok"),
        render: (text, record) => (
          <Link to={`/check-in-event/${record.id}`}>
            <Avatar
              shape="square"
              className="rounded"
              size={64}
              src={record.image_s}
            />
            <span className="ml-3">{record.name}</span>
          </Link>
        ),
      },
      {
        title: "Display date",
        dataIndex: "events_date",
        key: "Display date",
        type: "date",
        value: "",
        selectData: [],
        onChange: () => console.log("ok"),
        render: (text, record) => (
          <span>
            {`${record.events_details.start_date} - ${record.events_details.end_date}`}
          </span>
        ),
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "Location",
        type: "input",
        value: "",
        selectData: [],
        onChange: () => console.log("ok"),
        render: () => <span>Bangkok</span>,
      },
      {
        title: "Points",
        dataIndex: "type_points",
        key: "point",
        type: "input",
        align: "right",
        value: "",
        selectData: [],
        onChange: () => console.log("ok"),
        render: (text, record) => <span>{record.points}</span>,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        type: "select",
        value: "",
        selectData: [],
        onChange: () => console.log("ok"),
        render: (text, record) => (
          <TagStatus
            onClick={() => this.onChangeSwitch(record)}
            StatusValue={text}
          />
        ),
      },
      {
        title: "Action",
        key: "action",
        render: (text, record) => (
          <Dropdown
            trigger={["click"]}
            overlay={menu(record)}
            placement="bottomRight"
          >
            <Button type="link">
              <EllipsisOutlined />
            </Button>
          </Dropdown>
        ),
      },
    ];

    const headers = [
      { label: "Name", key: "name" },
      { label: "Detail", key: "detail" },
      { label: "Place", key: "place" },
      { label: "Start Date", key: "start_date" },
      { label: "End Date", key: "end_date" },
      { label: "Created At", key: "created_at" },
      { label: "Points", key: "points" },
      { label: "Status", key: "status" },
    ];

    const { loading, data, total, check_token } = this.state;
    return (
      <>
        {check_token === true && (
          <Layout
            title="Check in event"
            extraBtn={
              isCreate[0] === 1
                ? [
                    <Button
                      type="primary"
                      onClick={() =>
                        this.props.history.push("/check-in-event/create")
                      }
                    >
                      + Add Check in event
                    </Button>,
                  ]
                : []
            }
            breadcrumbNav={[
              {
                path: "/dashboard",
                breadcrumbName: "Dashboard",
              },
              {
                path: "/check-in-event",
                breadcrumbName: "Check in event",
              },
            ]}
          >
            <Spin spinning={loading} tip="Loading...">
              <AdvancedTableSearch
                fileName="artists"
                headers={headers}
                columns={columns}
                data={data}
                handleSearch={(value) => this.handleSearch(value)}
                onChangeSearch={(e) => this.handleSearch(e.target.value)}
                nonExport
                noDropdownSearch
                noFillter
                loading={loading}
                searchCondition={["image", "action", "point", "Display date"]}
                columnsFilter={columns}
                filterCondition={["action", "image"]}
                rowKey={(record) => record.id}
                total={total}
                onTableChange={this.handlePaggination}
              />
            </Spin>
          </Layout>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  menu: state.menus.menu,
});

const mapDispatchToProps = (dispatch) => ({
  userAction: bindActionCreators(userAction, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(CheckInEvent);
